import { get, del, put, post } from "../request";

/**
 * 教师题库管理（Question Bank Info Teacher Controller）
 * /trainAdmin/questionBankInfoTeacher
 *
 * 职责：题库本身的增删改查/分页（用 questionBankType 区分理论=1、实操=2）
 * 进入某个题库后的「题目列表」不在这里：
 * - 理论题 → questionInfoTeacher
 * - 实操题 → questionPracticalInfoTeacher
 */
const BANK = "/trainAdmin/questionBankInfoTeacher";

/** 教师创建的题库分页 GET /my-list */
export function getQuestionBankList(params) {
  return get(`${BANK}/my-list`, params);
}

/** 教师课程绑定的题库分页 GET /course-list */
export function getQuestionBankCourseList(params) {
  return get(`${BANK}/course-list`, params);
}

/** 查询课程关联的全部题库（按 courseId + questionBankType） GET /course/all/list */
export function getCourseQuestionBankList(params) {
  return get(`${BANK}/course/all/list`, params);
}

/** 删除题库 */
export function deleteQuestionBank(id) {
  return del(`${BANK}/${id}`);
}

/** 新增题库 */
export function addQuestionBank(data) {
  return post(BANK, data);
}

/** 修改题库 */
export function updateQuestionBank(data) {
  return put(BANK, data);
}

/** 查询题库详情 */
export function getQuestionBankInfo(id) {
  return get(`${BANK}/${id}`);
}



// WEBPACK FOOTER //
// ./src/api/questionBank/index.js